<style lang="less" scoped>
.root-edit-modal {
    padding: 0
}
.edit-v-card {
  height: 100%;
  display: flex;
  flex-direction: column;
}
</style>
<template>
  <v-row justify="center">
    <v-dialog
      v-model="showModal"
      scrollable
      max-width="1200px"
    >
      <v-card>
        <v-card-title>
          <span class="headline">{{ editedItem.id?'编辑':'新增' }}</span>
        </v-card-title>
        <v-divider />
        <v-card-text>
          <v-row>
            <v-col
              cols="4"
            >
              <v-select
                v-model="editedItem.type"
                :items="items"
                label="申请单类型"
                :disabled="editedItem.id!==undefined"
                @change="changeEditedType"
              />
            </v-col>
            <v-col cols="12">
              <HcReceipts
                v-if="editedItem.type===1"
                ref="hc"
                :parent-detail="parentDetail"
                :edited-item="editedItem"
                :positive-integer="positiveInteger"
                :decimal-rule="decimalRule"
              />
              <UnHcReceipts
                v-if="editedItem.type===2"
                ref="unhc"
                :parent-detail="parentDetail"
                :edited-item="editedItem"
                :positive-integer="positiveInteger"
                :decimal-rule="decimalRule"
              />            
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            text
            :disabled="loading"
            @click="cancel"
          >
            取消
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            :loading="loading"
            :disabled="!editedItem.type"
            @click="ok"
          >
            保存
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
  import { mapGetters } from "vuex";
  import HcReceipts from './HcReceipts'
  import UnHcReceipts from './UnHcReceipts' 
  import { subInitData, initSub, initunHcSub, createMonthHeader, createValue } from '../utils'
  import Util from '../../../../libs/util'
  import { budgetOrderCreateSubOrderApi, budgetOrderUpdateSubOrderApi } from '../service'
  export default {
    components: {
      HcReceipts,
      UnHcReceipts
    },
    props: {
      parentDetail: {
        type: Object,
      }
    },
    data() {
      this.items = [
        {
          text: 'HC申请单',
          value: 1
        },
        {
          text: '非HC申请单',
          value: 2
        }
      ]
      return {
        showModal: false,
        loading: false,
        editedItem: subInitData(),
      }
    },
    computed: {
      ...mapGetters('async', {
        analysis_leaf_titles: 'analysis_leaf_titles', // 分析
      }),
      cur_customer() {
        return this.$store.state.cur_customer
      },
    },
    methods: {
      positiveInteger(data) {
        if (Number(data) <= 0 || (data && Number(data).toFixed(0) !== data + '')) {
          return '请输入正整数'
        }
        return true
      },
      decimalRule(data) {
        if (data <= 0 || (data && !/^\d*(\.[1-9]|\.\d[1-9])*$/.test(data))) {
          return '请输入小数位不大于2的正数'
        }
        return true
      },
      show(data) {
        console.log('data', data)
        if (data && data.is_headcount === true) { // 编辑
          this.editedHC(data)
        } else if (data && data.is_headcount === false) {
          this.editedUnHC(data)
        } else { // 新增
          this.editedItem = subInitData()
          this.editedItem.order_id = this.parentDetail.id
        }
        this.showModal = true
      },
      editedHC(data) {
        const init_data_item_key = ['headcount_type', 'headcount_total', 'sequence_name']
        const init_data = subInitData()
        const current_data = Util.clone(data)
        init_data.type = current_data.is_headcount ? 1 : 2
        const need_key = ['id', 'team_id', 'remark', 'name', 'bfiles', 'headcount_type', 'future_expense']
        need_key.forEach(key => {
          init_data[key] = current_data[key]
        })
        init_data.future_expense = Number(init_data.future_expense)
        init_data.hc_child_item_arr = []

        current_data.headcounts.forEach(headcount => {
          const hc_child_item = initSub()
          init_data_item_key.forEach(key => {
            hc_child_item[key] = headcount[key]
          })
          const table_data = hc_child_item.table_data
          let month_arr = []
          const title_id_hash = {}
          // 构造动态表单
          headcount.items.forEach((item) => {
            const current_month = item.budget_month.slice(0, 7)
            month_arr.push(current_month)
            if (!title_id_hash[item.title_id]) {
              title_id_hash[item.title_id] = []
            }
            title_id_hash[item.title_id].push({
              budget_amount:item.budget_amount,
              budget_month: item.budget_month
            })
          })
          // // 构造table的header
          month_arr = [...new Set(month_arr)].sort()
          if (month_arr.length) {
            table_data._header.splice(1, 1)
            month_arr.forEach(item => {
              table_data.
                _header.splice(
                  table_data._header.length - 1,
                  0,
                  createMonthHeader({value:item})
                )
            })
          }
          // 构造table的item
          if (Object.keys(title_id_hash).length) {
            table_data._value.splice(0, 1)
            const current_value = createValue()
            Object.keys(title_id_hash).forEach(key => {
              current_value.title_id = Number(key)
              title_id_hash[key].forEach(month_value => {
                const month = month_value.budget_month.slice(0, 7)
                current_value[month] = Number(month_value.budget_amount)
              })
              table_data._value.splice(table_data._value.length - 2, 0, {...current_value})
            })
          }
          init_data.hc_child_item_arr.push(hc_child_item)
        })
        init_data.order_id = undefined
        this.editedItem = init_data
      },
      editedUnHC(data) {
        const init_data = subInitData()
        const current_data = Util.clone(data)
        init_data.type = current_data.is_headcount ? 1 : 2
        const need_key = ['id', 'team_id', 'remark', 'name', 'bfiles', 'future_expense']
        need_key.forEach(key => {
          init_data[key] = current_data[key]
        })
        init_data.future_expense = Number(init_data.future_expense)
        init_data.un_hc_child_item_arr = initunHcSub()
        let month_arr = []
        const title_id_hash = {}
        // 构造动态表单
        current_data.items.forEach((item) => {
          const current_month = item.budget_month.slice(0, 7)
          month_arr.push(current_month)
          if (!title_id_hash[item.title_id]) {
            title_id_hash[item.title_id] = []
          }
          title_id_hash[item.title_id].push({
            budget_amount:item.budget_amount,
            budget_month: item.budget_month
          })
        })
        // 构造table的header
        month_arr = [...new Set(month_arr)].sort()
        if (month_arr.length) {
          init_data.un_hc_child_item_arr._header.splice(1, 1)
          month_arr.forEach(item => {
            init_data.
              un_hc_child_item_arr._header.
              splice(
                init_data.un_hc_child_item_arr._header.length - 1,
                0,
                createMonthHeader({value:item})
              )
          })
        }
        // 构造table的item
        if (Object.keys(title_id_hash).length) {
          init_data.un_hc_child_item_arr._value.splice(0, 1)
          Object.keys(title_id_hash).forEach(key => {
            const current_value = createValue()
            current_value.title_id = Number(key)
            title_id_hash[key].forEach(month_value => {
              const month = month_value.budget_month.slice(0, 7)
              current_value[month] = Number(month_value.budget_amount)
            })
            init_data
              .un_hc_child_item_arr
              ._value
              .splice(
                init_data.un_hc_child_item_arr._value.length - 2,
                0,
                current_value
              )
          })
        }
        init_data.order_id = undefined
        this.editedItem = init_data
      },
      cancel() {
        if (this.editedItem.type === 1) {
          this.$refs.hc.refresh()
        } 
        if (this.editedItem.type === 2) {
          this.$refs.unhc.refresh()
        }
        this.editedItem.type = ''
        this.showModal = false
      },
      ok() {
        const ref_type = this.editedItem.type
        const ref_name = this.editedItem.type === 1 ? 'hc' : 'unhc'
        const postApi = this.editedItem.id === undefined ? budgetOrderCreateSubOrderApi : budgetOrderUpdateSubOrderApi
        if (ref_type && this.$refs[ref_name].validate()) {
          const params = this.$refs[ref_name].getData()
          if (params.id === undefined) {// todo
            params.order_id = this.parentDetail.id
          }
          this.loading = true
          postApi(params).then(() => {
            this.$emit('success')
            this.cancel()
            this.$Message.success({
              content: this.editedItem.id === undefined ? '新增成功' : '编辑成功',
              duration:0.9
            })
          }).finally(() => {
            this.loading = false
          })
        }
      },
      changeEditedType(data) {
        if (data === 1) {
          this.editedItem.team_id = 14 // hr部门的id
          this.$nextTick(() => {
            this.$refs.hc.refresh()
          })
        } else {
          this.editedItem.team_id = null
          this.$nextTick(() => {
            this.$refs.unhc.refresh()
          })
        }
      }
    }
  }
</script>
